import React, {useEffect, useState} from 'react';
import {Box, Container, Link, Typography} from "@mui/material";
import { useStore } from "./store";


const ContactBlock = () => {
    const { settings, setSettings } = useStore();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const mapSrc = "https://yandex.ru/map-widget/v1/?from=mapframe&indoorLevel=1&ll=32.052417%2C54.793917&mode=poi&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D99680966099&source=mapframe&utm_source=mapframe&z=18";

    const mapStyle = {
        border: '1px solid #ccc',
        width: isMobile ? '100%' : '100%',
        height: isMobile ? '400px' : '900px',
    };

    return (
        <Container>
            <Typography variant={'h5'} gutterBottom mt={2}> Контакты</Typography>
            <Typography mt={2}><Link href={`tel:${settings.phone}`}>📞 Телефон: {settings.phone}</Link></Typography>
            <Typography mt={2}><Link href={`mailto:${settings.email}`}>✉️ E-mail: {settings.email}</Link></Typography>
            <Typography mt={2}><Link>📍 Адрес: {settings.address}</Link></Typography>

            <Box mt={2}>
                <iframe
                    src={mapSrc}
                    style={mapStyle}
                    allowFullScreen
                    loading="lazy"
                    title="Yandex Map"
                />
            </Box>
        </Container>
    );
};

export default ContactBlock;
